<div class="row mt-4">
    <div class="col-12">
        <h1 class="centrar_contenido">Reporte histórico <br> de calificaciones</h1>
    </div>
</div>

<!-- CRITERIOS DE BUSQUEDA -->
<div class="row mt-5 align-items-center">
    <div class="hr-amarillo mr-3"></div>
    <h6 class="mb-0">Criterios de búsqueda</h6>
</div>
<form [formGroup]="parametrosForm">
    <div class="row mt-5">
        <div class="col-3">
            <label class="titulo_criterios" for="exampleFormControlSelect2">RUT Estudiante</label>
            <label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
            <div class="input-group mb-0">
                <input type="text" class="form-control select_criterios" placeholder="11111111-1"
                    aria-describedby="basic-addon2" (focusout)="seleccionFiltro('rut')" [(ngModel)]="rutEstudiante"
                    formControlName="rut" [ngClass]="{'resaltar': resaltarError && rut.length != 0}"
                    >
                    <div *ngIf="submitted && tieneErrores['rut']" class="invalid-feedback" style="display: flex;">
                        <div *ngIf="tieneErrores['rut']">Campo requerido</div>
                    </div>
            </div>
        </div>
        <div class="col-2">
            <label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
            <label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
            <select class="form-control select_criterios" [(ngModel)]="filtroAnyoSeleccionado"
                (ngModelChange)="seleccionFiltro('anyo')" formControlName="anyo">
                <option [value]="0">Seleccionar</option>
                <option *ngFor="let anyo of filtroAnyos" [value]="anyo">{{anyo}}</option>
            </select>
            <div *ngIf="submitted && tieneErrores['anyo']" class="invalid-feedback" style="display: flex;">
                <div *ngIf="tieneErrores['anyo']">Campo requerido</div>
            </div>
        </div>
        <div class="col-2">
            <label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
            <label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
            <select class="form-control select_criterios" [(ngModel)]="filtroPeriodoSeleccionado"
                (ngModelChange)="seleccionFiltro('periodo')" formControlName="periodo">
                <option [value]="0">Seleccionar</option>
                <option *ngFor="let periodo of filtroPeriodos" [value]="periodo.periodoAcademicoId">
                    {{periodo.periodoDescripcion}}</option>
            </select>
            <div *ngIf="submitted && tieneErrores['periodo']" class="invalid-feedback" style="display: flex;">
                <div *ngIf="tieneErrores['periodo']">Campo requerido</div>
            </div>
        </div>
        <div class="col-2">
            <label class="titulo_criterios" for="exampleFormControlSelect2">ID Sección</label>
            <div class="input-group mb-0">
                <mat-autocomplete #autoSeccion="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let seccion of filteredIdSeccion | async" [value]="seccion">
                        {{seccion?.id}}
                    </mat-option>
                </mat-autocomplete>
                <input type="text" class="form-control select_criterios" placeholder="1111111" 
                    [formControl]="searchSeccionForm" formControlName="seccion" aria-describedby="basic-addon2"
                    [matAutocomplete]="autoSeccion"  [ngClass]="{ 'is-invalid': submitted && tieneErrores['seccion'] }" (ngModelChange)="seleccionFiltro('seccion')" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)">
            </div>
        </div>
        <div class="col-1 centrar_iconos_botones">
            <button class="boton-buscar" data-toggle="tooltip" data-placement="top" title="BUSCAR"
            alt="BUSCAR" (click)="busqueda()"><i class="bi bi-search"></i></button>
        </div>
        <div class="col-1 centrar_iconos_botones">
            <button class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip" data-placement="top"
            title="ELIMINAR" alt="ELIMINAR" (click)="limpiarFiltros('')"><i class="bi bi-x"></i></button>
        </div>
    </div>
</form>
<!-- FIN CRITERIO DE BUSQUEDA -->
<div class="alert alert-danger tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="error">
    <i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{ error }}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
      <span aria-hidden="true" class="alert-danger">&times;</span>
    </button>
  </div>
<div class="row justify-content-end mt-5 mb-4">
    <button (click)="generarSolicitudReporte()" [disabled]="!habilitarBtnGenerarReporte" class="btn boton-primario mt-4 mr-4"
		data-toggle="tooltip" data-placement="top" title="GENERAR REPORTE" alt="GENERAR REPORTE"
		style="position: absolute; z-index: 1;">
		GENERAR REPORTE
	</button>
  </div>
<!-- TABLA -->
<div style="margin-top: 20px;">
    <table *ngIf="renderTabla" [dtOptions]="dtOptions" datatable class="row-border hover table-striped display nowrap "
        aria-describedby="tabla historico calificaciones">
        <thead class="header_tabla">
            <tr>
                <th>Id Proceso</th>
                <th>Fecha</th>
                <th>Usuario</th>
                <th>Estado del proceso</th>
                <th>Observaciones</th>
                <th class="text-center">
                    <div class="d-flex justify-content-between">
                      <div>Descarga PDF</div>
                      <div>Descarga Excel</div>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let reporte of listaReportes">
                <td class="py-3"><p class="celda">{{reporte.procesoId}}</p></td>
                <td class="py-3"><p class="celda">{{reporte.fechaProceso}}</p></td>
                <td class="py-3"><p class="celda">{{reporte.usuarioCreacion}}</p></td>
                <td class="py-3">
                    <span class="badge badge-pill finalizado d-flex justify-content-center py-2" *ngIf="reporte.estadoProceso == 'F'">Finalizado</span>
                    <span class="badge badge-pill en_proceso d-flex justify-content-center py-2" *ngIf="reporte.estadoProceso == 'EP'">En proceso</span>
                    <span class="badge badge-pill error d-flex justify-content-center py-2" *ngIf="reporte.estadoProceso == 'ER'">Error</span>
                </td>
                <td class="py-3 td-mensaje-observaciones"><p class="celda ">{{reporte.observacion}}</p></td>
                <td>
                    <div class="d-flex justify-content-center align-items-center"  *ngIf="reporte.estadoProceso == 'F'">
                      <div style="margin-right: 50%;" ><button class="btn p-0" data-toggle="tooltip" data-placement="top" (click)="obtenerReportePDF(reporte.procesoId)"
                        title="DESCARGAR REPORTE PDF" alt="DESCARGAR REPORTE PDF">
                        <i class="bi bi-filetype-pdf icono-tabla"></i>
                      </button></div>
                      <div><button class="btn p-0" data-toggle="tooltip" data-placement="top" (click)="obtenerReporteExcel(reporte.procesoId)"
                        title="DESCARGAR REPORTE EXCEL" alt="DESCARGAR REPORTE EXCEL">
                        <i class="bi bi-filetype-xlsx icono-tabla"></i>
                      </button></div>
                    </div>
                  </td>
            </tr>
        </tbody>
    </table>
    <table *ngIf="!renderTabla" [dtOptions]="dtOptions" datatable class="row-border hover table-striped display nowrap "
        aria-describedby="tabla historico calificaciones">
        <thead class="header_tabla">
            <tr>
                <th>Id Proceso</th>
                <th>Fecha</th>
                <th>Usuario</th>
                <th>Estado del proceso</th>
                <th>Observaciones</th>
                <th class="text-center">Descarga PDF</th>
                <th class="text-center">Descarga Excel</th>
            </tr>
        </thead>
        <tbody>
           
        </tbody>
    </table>
</div>

<!-- FIN TABLA -->